import { Box } from 'braid-design-system';

import useAuthenticated from 'src/hooks/useAuthenticated';
import { useSRPFeedbackPromptEnabled } from 'src/store/featureFlags/hooks';
import { selectSearchTag } from 'src/store/featureFlags/selectors';
import { useSelector } from 'src/store/react';
import {
  selectLocationPageNumber,
  selectPaginationTotalPages,
} from 'src/store/selectors';

import Pagination from '../../Pagination/Pagination';
import SaveSearchSection from '../../SaveSearchSection/SaveSearchSection';
import { SRPFeedbackPrompt } from '../SRPFeedbackPrompt/SRPFeedbackPrompt';

export const LIST_FOOTER_ITEM_SPACING = 'xlarge'; // listFooterItemSpacing = 'xlarge';

export const Footer = () => {
  const authenticateState = useAuthenticated();

  const totalPages = useSelector(selectPaginationTotalPages);
  const shouldHavePagination = totalPages > 1;

  const srpFeedbackPromptFlag = useSRPFeedbackPromptEnabled();
  const isNewToYou = useSelector(selectSearchTag) === 'new';
  const isFirstPage = useSelector(selectLocationPageNumber) === 1;
  const shouldShowSRPFeedbackPrompt =
    !isNewToYou && isFirstPage && srpFeedbackPromptFlag;

  const shouldShowSaveSearchAbovePagination =
    authenticateState === 'authenticated';
  const shouldShowSaveSearchUnderPagination =
    authenticateState === 'unauthenticated';
  return (
    <>
      {shouldShowSRPFeedbackPrompt && <SRPFeedbackPrompt />}
      {shouldShowSaveSearchAbovePagination && (
        <SaveSearchSection spaceTop={LIST_FOOTER_ITEM_SPACING} />
      )}
      {shouldHavePagination && (
        <Box paddingTop={LIST_FOOTER_ITEM_SPACING}>
          <Pagination />
        </Box>
      )}
      {shouldShowSaveSearchUnderPagination && (
        <SaveSearchSection spaceTop={LIST_FOOTER_ITEM_SPACING} />
      )}
    </>
  );
};
